import React from 'react';
import ReactSelect from '../ReactSelect';

export type ProfileType = (typeof profileTypeOptions)[number]['value'];

const profileTypeOptions = [
  {
    value: 1,
    label: 'Individual',
  },
  {
    value: 2,
    label: 'Company',
  },
] as const;

export const ProfileTypePicker = ({
  value,
  isClearable,
  onChange,
}: {
  value?: ProfileType;
  isClearable?: boolean;
  onChange: (value?: ProfileType) => void;
}) => (
  <ReactSelect
    placeholder="profile type"
    isClearable={isClearable}
    value={profileTypeOptions.find((option) => value === option.value)}
    styles={{
      menu: (base) => ({
        ...base,
        minWidth: '150px',
      }),
    }}
    onChange={(value) => {
      onChange(value?.value ?? undefined);
    }}
    options={profileTypeOptions}
  />
);
